import React from 'react';
import FilterComponent from 'components/filter_component/View'
import IdeaPanel from 'components_newui/idea_panel/View'


const TaggedIdeasSection = ({
  // ideasTag,
  // setIdeasTag,
  challengeTaggedIdea,
  // ideasChallenge,
  // activeFilters,
  // setActiveFilters,
  // nameQuery,
  // setNameQuery,
  classes,
  noDraftIdeasImg,
}) => {


// const [ideasTag,setIdeasTag] = React.useState([])
const [searchTerm, setSearchTerm] = React.useState("");
  // const applySearch = () => {
  //  const searchFilterValue = challengeTaggedIdea.filter((item) =>
  //       item.title.toLowerCase().includes(nameQuery.toLowerCase())
  //     )
  //   setIdeasTag(searchFilterValue);
  // };

  // const resetSearch = () => {
  //   setNameQuery('');
  //   setIdeasTag(challengeTaggedIdea);
  // };

  const filteredData = challengeTaggedIdea?.filter(item =>
    item?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  // const sortedFiltered = React.useMemo(() => {
  //   return [...filteredData].sort(
  //     (a, b) => (b?.created?.timestamp ?? 0) - (a?.created?.timestamp ?? 0)
  //   );
  // }, [filteredData]);


  



  const sortedFiltered = React.useMemo(() => {
    return [...filteredData].sort((a, b) => {
      const aSelected = a.status === "SELECTED_FOR_HACKATHON";
      const bSelected = b.status === "SELECTED_FOR_HACKATHON";

      // Get timestamps for comparison
      const aTimestamp = a.created?.timestamp || a.created || 0;
      const bTimestamp = b.created?.timestamp || b.created || 0;

      // If selection status differs, selected items come first
      if (aSelected !== bSelected) {
        return bSelected - aSelected; // true (1) - false (0) = 1, so selected comes first
      }

      // If same selection status, sort by date (newest first)
      return bTimestamp - aTimestamp;
    });
  }, [filteredData]); // Fixed: use filteredData1 not filteredData

  

  const handleReset = () => {
    setSearchTerm(""); // Reset search term
  };


  return (
    <div className={classes.tagwrp}>
      <div className={classes.header}>Ideas tagged ({filteredData?.length})</div>

      <div className={classes.tagsfilter}>
        {/* <FilterComponent
          activeFilters={activeFilters}
          serviceLineOrgs={[]}
          ideaStatusFilter={false}
          types={[]}
          handleActiveFilters={setActiveFilters}
          search={nameQuery}
          setSearch={setNameQuery}
          applySearch={applySearch}
          resetSearch={resetSearch}
        /> */}

      <input
        type="text"
        name="search"
        placeholder="Search by title..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        className={classes.input_search}
      />
      <button type='button' className={classes.resetbtn} onClick={handleReset}>Reset</button>

      </div>

      {filteredData.length > 0 ? (
        <div className={classes.idea_grid}> 
          {sortedFiltered.map((idea) => (
            <IdeaPanel key={idea.id} urlId={idea.id} isInnovate={idea?.isInnovate}  idea={idea} />
          ))}
        </div>
      ) : (
        <div className={classes.nofoundwrp}>
          <img
            src={noDraftIdeasImg}
            className={classes.no_idea_img}
            alt="noidea img"
          />
          <div className={classes.no_idea_title}>No ideas found</div>
        </div>
      )}
    </div>
  );
};

export default TaggedIdeasSection;
